export enum TicketDistribution {
    Automated = 0,
    Manual = 1,
    Venue = 2,
    CustomField = 3,
    InviteeOnly = 4
}
